<template>
    <div class="width-full">
        <v-container fluid grid-list-xl class="container-symptoms-questions general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

            <v-layout row wrap class="general-info page-content with-alerts pf-standard-mobile pf-mobile-related-symptoms">
                <v-flex lg4 offset-lg4 md8 offset-md2 sm8 offset-sm2 xs12 class="no-padding">
                    <p class="page-title-pf no-margin-bottom hidden-xs-only" >{{text('api.pdf.pageTitle.relatedSymptoms')}}</p>
                    <standard-stepper  :steps="step"></standard-stepper>
                    <description class="margin-top-xl"></description>

                </v-flex>

                <br />

                <v-flex lg4 offset-lg4 md6 offset-md3 sm8 offset-sm2 xs12 class="no-padding-right no-padding-left">

                    <div class="main-symptom-section start-assessment-section-pf related-symptoms-page-pf">
                    <v-card class="pf-related-symptoms mobile-pf">
                        <v-card-text>

                            <div v-if="getRelatedSymptomList.length > 0">
                                <div v-for="(relatedSymptom, index) in getRelatedSymptomList" :key="relatedSymptom.code" class="symptoms">
                                    <v-checkbox
                                        :label="relatedSymptom.name"
                                        v-model="relatedSymptom.state"
                                        :true-value="`${getRelatedSymptomStates.HAVE_SYMPTOM}`"
                                        :false-value="`${getRelatedSymptomStates.NONE}`"
                                        @change="handleChangeRelatedSymptom(relatedSymptom, index)"
                                        hide-details
                                    ></v-checkbox>
                                </div>
                            </div>
                        </v-card-text>

                        <v-card-actions class="pf-actions pf-footer hidden-xs-only">
                                <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn">
                                    <v-icon>keyboard_arrow_left</v-icon>
                                    {{ text('api.button.back') }}
                                </v-btn>
                                <v-btn flat color="primary" @click="goToNextPage"  class="footer-btn footer-btn-next">
                                    {{ text('api.button.evaluate')}}
                                    <v-icon>keyboard_arrow_right</v-icon>
                                </v-btn>
                        </v-card-actions>
                    </v-card>

                    </div>
                </v-flex>

            </v-layout>

            <v-layout>
                <v-flex>
                    <div class="footer pf-standard-mobile hidden-sm-and-up">

                            <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn back-pf">
                                <v-icon>keyboard_arrow_left</v-icon>
                                {{ text('api.button.back') }}
                            </v-btn>

                            <mobile-stepper :steps="step"></mobile-stepper>

                            <v-btn flat color="primary" @click="goToNextPage" class="footer-btn footer-btn-next next-pf">
                                {{ text('api.button.next') }}
                                <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>

                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import HeaderBar from "../../shared/HeaderBar";
    import TopBar from '../../../../common/components/shared/TopBar';
    import Description from '../../shared/Description';
    import {mapGetters} from 'vuex';
    import StandardStepper from '../../shared/StandardStepper';
    import MobileStepper from '../../shared/MobileStepper';

    export default {
        name: 'RelatedSymptomsPage',
        components: {
            HeaderBar,
            TopBar,
            Description,
            StandardStepper,
            MobileStepper
        },
        computed: {
            ...mapGetters({
                isAdmin: 'UserStore/getIsAdmin',
                getRelatedSymptomList: 'PfRelatedSymptomsStore/getRelatedSymptomList',
                getRelatedSymptomStates: 'PfRelatedSymptomsStore/getRelatedSymptomStates',
            })
        },

        data() {
            return {
                isFooterNextBtnEnabled: false,
                step: 4,
                selectedSymptoms: []
            }
        },

        beforeCreate() {
            if (typeof this.$route.query.referral === "undefined" || this.$route.query.referral !== "testsTreeNode") {
                this.$store.commit('SymptomsQuestionsStore/resetStore');
                this.$store.commit('AssessmentAlertsStore/resetStore');
            }
        },

        methods: {


            goToPreviousPage() {
                this.$router.push('/pathfinder/main-symptom');
            },

            goToNextPage() {
                this.$router.push('/pathfinder/symptom-questions');
            },

            handleChangeRelatedSymptom(changedRelatedSymptom, index) {
                let that = this;
                that.selectedSymptoms = [];
                this.getRelatedSymptomList.forEach(function (symptom, index) {
                    that.selectedSymptoms.push(symptom.state)

                    if(that.selectedSymptoms.includes('HAVE_SYMPTOM')) {
                        that.isFooterNextBtnEnabled = true;
                    } else {
                        that.isFooterNextBtnEnabled = false;
                    }


                });

                this.$store.dispatch("PfRelatedSymptomsStore/handleChangeRelatedSymptomState", {
                    newSymptomState: changedRelatedSymptom.state,
                    symptomCode: changedRelatedSymptom.code
                })
            },

            handleNoOtherSymptomsState(noOtherSymptoms) {

                axios.post(process.env.API_BASE_URL_PATHFINDER  + '/assessment/noOtherSymptoms', {
                    value: noOtherSymptoms
                });
            }

        },

        created () {
            this.$store.dispatch('PfRelatedSymptomsStore/loadRelatedSymptomList');
        },
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .container-symptoms-questions.grid-list-xl {

        .page-content{
            margin-top: 40px;

        }

        .related-symptoms {

            .related {
                padding: 0 20px 30px;
            }
        }

        .selected-symptoms {
            padding: 12px 0;


            .shared-questions {
                padding-left: 20px;
            }
        }
    }

    .btn-menu {
        max-width: 50px;
        margin-right: 50px;

        .settings {
            width: 15%;
        }
    }

    .btn-logout {
        max-width: 50px;
        margin-right: 50px;
    }

    .toolbar--fixed.header {
        background-color: $color-on-primary;
        padding: 0 20px;
        overflow: hidden;
        box-shadow: none;
        border-bottom: 3px solid $color-gray-lightest;
    }

    .user {
        width: 8%;
        margin-right: 10px;
    }

    .top-bar-no-margin{
        height: 50px;
    }

    .symptoms-questions-content {
        margin-top: 22px !important;
    }
    .alerts-top {
        display: inline-flex;
    }

    .scrolling-content-symptoms {
        top: 140px;
        position: fixed;
        margin-left: auto;
        margin-right: auto;
        bottom: 70px;
        overflow: auto;
        padding-top: 0;
        width: 100%;
        overflow-x: hidden;
    }

    .topbar-patient-info-content {
        position: fixed;
        right: 175px !important;
    }


    .scrolling-content.path {
        top: 110px !important;
    }

    .scrolling-content {
        overflow: hidden !important;
    }

    .pf-related-symptoms .card__text  > div {
        height: 420px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .card__actions.pf-actions {
        position: relative !important;
    }

    .main-symptom-section.start-assessment-section-pf {
        padding: 0 !important;
    }


    @media only screen and (max-width: 600px) {
        .pf-standard-mobile.pf-mobile-related-symptoms {
            margin-top: 0 !important;
            background-color: $color-gray-lightest;
        }

        .footer-btn-next.next-pf {
            position: absolute;
            right: 0;
            bottom: 4px;
        }

        .footer-btn.back-pf {
            position: absolute;
            top: 4px;
        }

        .pf-standard-mobile {
            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-brand-primary;
            }
        }

        .main-symptom-section.start-assessment-section-pf.related-symptoms-page-pf{

            height: auto !important;
            margin-bottom: 0 !important;

            .pf-related-symptoms {

                .card__text {
                    height: calc(100vh - 247px) !important;
                    overflow: auto;
                }

            }

        }
    }

    @media only screen and (min-width: 601px) {
        .pf-standard-mobile.pf-mobile-related-symptoms {
            margin-top: 30px !important;
        }

        .pf-standard-mobile {
            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-brand-primary;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/standard-forms/related-symptoms/RelatedSymptomsPage.vue